// src/lib/opportunity/oppTodoItemClient.ts

import { opportunityFetch } from "./opportunityFetch.js";
import type { OppTodoItem } from "./oppTodoItemTypes.js";

export function listOppTodoItems(opportunityId: string) {
  const q = new URLSearchParams({ opportunity_id: opportunityId });
  return opportunityFetch<{ ok: true; items: OppTodoItem[] }>(
    `/api/opportunity/todo-list?${q.toString()}`,
    { method: "GET" },
  );
}

export type UpsertOppTodoItemPayload = {
  id?: string;
  opportunity_id?: string;
  label: string;
  sort_order?: number;
  due_date?: string | null;
};

export function upsertOppTodoItem(payload: UpsertOppTodoItemPayload) {
  return opportunityFetch<{ ok: true; item: OppTodoItem }>("/api/opportunity/todo-upsert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function toggleOppTodoItem(id: string, completed: boolean) {
  return opportunityFetch<{ ok: true; item: OppTodoItem }>("/api/opportunity/todo-toggle", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, completed }),
  });
}

export function deleteOppTodoItem(id: string) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/todo-delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
}

export function reorderOppTodoItems(opportunityId: string, orderedIds: string[]) {
  return opportunityFetch<{ ok: true }>("/api/opportunity/todo-reorder", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ opportunity_id: opportunityId, ordered_ids: orderedIds }),
  });
}
